//Global styles (not load priority)
document.addEventListener('DOMContentLoaded', function () {

    Flickity.createMethods.push('_createPrevNextCells');

    Flickity.prototype._createPrevNextCells = function () {
        this.on('select', this.setPrevNextCells);
    };

    Flickity.prototype.setPrevNextCells = function () {
        // remove classes
        changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
        changeSlideClasses(this.nextSlide, 'remove', 'is-next');
        // set slides
        var previousI = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
        var nextI = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
        this.previousSlide = this.slides[previousI];
        this.nextSlide = this.slides[nextI];
        // add classes
        changeSlideClasses(this.previousSlide, 'add', 'is-previous');
        changeSlideClasses(this.nextSlide, 'add', 'is-next');
    };

    function changeSlideClasses(slide, method, className) {
        if (!slide) {
            return;
        }
        slide.getCellElements().forEach(function (cellElem) {
            cellElem.classList[method](className);
        });
    }

});

document.addEventListener("DOMContentLoaded", function () {
    if (typeof (document.querySelector('#blogSlider')) != 'undefined' && document.querySelector('#blogSlider') != null) {
        var blogSlider = new Flickity('#blogSlider', {
            pageDots: false,
            prevNextButtons: true,
            contain: false,
            wrapAround: true,
            freeScroll: false,
            cellAlign: "left",
            freeScrollFriction: 0.03,
    
            on: {
                ready: function () {
                    const galleryLength = this.getCellElements().length;
                    this.selectCell(Math.floor(galleryLength * Math.random()), true, true);
                },
                change: function (index) {
                }
            }
        });
    }
});

$(document).ready(function () {
    //Jquery initial
    var faq = $('.co-faq-section-3');


    if (faq.length) {
        let accItem = faq.find('.co-faq-section-3--item .co-faq-section-3--item-title');
        accItem.next().hide();
        accItem.click(function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('active');
            $(this).next().slideToggle();
        });
    }

    $('.co-faq-section-3--item').first().addClass('active');
    $('.co-faq-section-3--item').first().find('.co-faq-section-3--item-title').next().slideDown();

}, jQuery);